import { render, staticRenderFns } from "./priceapplication.vue?vue&type=template&id=0b1db56c&scoped=true&"
import script from "./priceapplication.vue?vue&type=script&lang=js&"
export * from "./priceapplication.vue?vue&type=script&lang=js&"
import style0 from "./priceapplication.vue?vue&type=style&index=0&id=0b1db56c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1db56c",
  null
  
)

export default component.exports